function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ChangeHighlightedImmutableUnderReviewControl from '../reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { FormattedNumberInput } from '..';
export function ChangeHighlightedInputFormFieldRow(_ref) {
  let {
    fieldName,
    type = 'text',
    label,
    object,
    labelColSpan = 3,
    valueColSpan = 3,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: labelColSpan
  }, t(`${label || fieldName}`)), /*#__PURE__*/React.createElement(Col, {
    md: valueColSpan
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, _extends({
    name: fieldName,
    object: object
  }, props, {
    as: type === 'text' ? Form.Control : FormattedNumberInput
  }))));
}